import { get, post, deleteRequest } from 'helpers/api';
import { isBlank } from 'helpers/string_helpers';
import { pickBy } from 'lodash';

import { toggleAlert } from './ui';
import { setFullQuery } from './query';
import { setUserBounds, enableAutoBoundsSearching } from './coordinates';
import { retrieveLeases, retrieveSales } from './search';
import { getSavedSearchIndexPath } from '../selectors/paths';
import { getDeleteSavedSearch } from '../selectors/saved_searches';

export const SET_SAVED_SEARCHES = 'SET_SAVED_SEARCHES';
export const setSavedSearches = searches => ({
  searches,
  type: SET_SAVED_SEARCHES
});

export const START_LOAD_SEARCHES = 'START_LOAD_SEARCHES';
export const startLoadSearches = () => ({
  type: START_LOAD_SEARCHES
});

export const START_DELETE_SEARCH = 'START_DELETE_SEARCH';
export const startDeleteSearch = search => ({
  search,
  type: START_DELETE_SEARCH
});

export const END_DELETE_SEARCH = 'END_DELETE_SEARCH';
export const endDeleteSearch = () => ({
  type: END_DELETE_SEARCH
});

export const loadSearchQuery = search => (
  (dispatch, getState) => {
    const query = filterQuery(search.query);
    dispatch(setFullQuery(query));
    if (Object.keys(search.coordinates).length > 0) {
      dispatch(enableAutoBoundsSearching());
      dispatch(setUserBounds(search.coordinates.userBounds));
    }
    const { ui } = getState();
    if (ui.currentTab === 'lease') {
      dispatch(retrieveLeases());
    } else {
      dispatch(retrieveSales());
    }
  }
);

export const loadSavedSearches = () => (
  (dispatch, getState) => {
    const path = getSavedSearchIndexPath(getState());
    dispatch(startLoadSearches());
    const { ui } = getState();
    const model = ui.currentTab === 'lease' ? 'Research::Lease' : 'Research::Sale';
    return get(path, { params: { modelType: model } }).then((searches) => {
      dispatch(setSavedSearches(searches));
    });
  }
);

export const saveSavedSearch = (name) => {
  return (dispatch, getState) => {
    const state = getState();
    const path = getSavedSearchIndexPath(state);
    const query = filterQuery(state.query);
    const { autoBoundsSearchingEnabled, mapBounds, ...filteredCoordinates } = { ...state.coordinates };
    const model = state.ui.currentTab === 'lease' ? 'Research::Lease' : 'Research::Sale';
    return post(path, {
      savedSearch: {
        name: name,
        query: query,
        modelType: model,
        coordinates: filteredCoordinates
      }
    }).then(({ message }) => {
      dispatch(loadSavedSearches());
      dispatch(toggleAlert(message, false));
    }).catch(() => {
      dispatch(toggleAlert('This search already exists. Please try a new query', true));
    });
  };
};

export const deleteSavedSearch = () => (
  (dispatch, getState) => {
    const path = getSavedSearchIndexPath(getState());
    const deletedSavedSearch = getDeleteSavedSearch(getState());
    return deleteRequest(`${path}/${deletedSavedSearch.id}`).then(({ message }) => {
      dispatch(loadSavedSearches());
      dispatch(endDeleteSearch());
      dispatch(toggleAlert(message, true));
    }).catch(() => {
      dispatch(toggleAlert('Unable to delete search.', true));
    });
  }
);

const filterNestedObject = (obj) => {
  const filteredObject = pickBy(obj, (value) => {
    if (Array.isArray(value)) return value.length > 0;
    return !isBlank(value);
  });

  const isObjectEmpty = Object.keys(filteredObject).length == 0;
  return isObjectEmpty ? null : filteredObject;
};

const filterQuery = (query) => {
  const { filtersApplied, propertyPage, ...filteredQuery } = query;

  filteredQuery.addressFilter = filterNestedObject(filteredQuery.addressFilter);
  filteredQuery.industrialFilter = filterNestedObject(filteredQuery.industrialFilter);
  filteredQuery.propertyFilter = filterNestedObject(filteredQuery.propertyFilter);
  filteredQuery.saleFilter = filterNestedObject(filteredQuery.saleFilter);

  return filterNestedObject(filteredQuery);
};
